import { AuthStore } from '@vectord/utils';

class TokenStore {
  static setToken(value: string | null) {
    AuthStore.set({ jwt: value });
  }

  static getToken() {
    return (AuthStore.get() || {}).jwt;
  }
}

export default TokenStore;
